const IconMoon = ({ size = 44 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z" />
  </svg>
);

const IconClock = ({ size = 13 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" />
    <polyline points="12 6 12 12 16 14" />
  </svg>
);

const IconArrowRight = ({ size = 14 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <line x1="5" y1="12" x2="19" y2="12" />
    <polyline points="12 5 19 12 12 19" />
  </svg>
);

const PopUpProgramarNew2 = ({ setPopupStatus, color_botton, btnTextColor }) => {
    return (
        <div style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "16px",
            padding: "8px 24px 28px 24px",
            textAlign: "center",
        }}>

            {/* Ilustración */}
            <div style={{
                width: "88px",
                height: "88px",
                borderRadius: "28px",
                background: `color-mix(in srgb, ${color_botton || "#6C63FF"} 10%, transparent)`,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: color_botton || "#6C63FF",
            }}>
                <IconMoon size={44} />
            </div>

            {/* Texto */}
            <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                <h3 style={{
                    margin: 0,
                    fontSize: "20px",
                    fontWeight: "800",
                    color: "#1A1A2E",
                    letterSpacing: "-0.3px",
                }}>
                    Estamos cerrados por ahora
                </h3>
                <p style={{
                    margin: 0,
                    fontSize: "14px",
                    color: "#8888A0",
                    lineHeight: 1.55,
                }}>
                    Pronto abriremos de nuevo. Puedes explorar el menú y tener
                    tu pedido listo para cuando abramos.
                </p>
            </div>

            {/* Pill de horario */}
            <div style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                background: "#F7F7FA",
                border: "1.5px solid #EBEBF0",
                borderRadius: "99px",
                padding: "10px 18px",
                fontSize: "13px",
                fontWeight: "600",
                color: "#5C5C7A",
            }}>
                <span style={{ color: color_botton || "#6C63FF", display: "flex" }}>
                    <IconClock size={13} />
                </span>
                Puedes programar tu pedido
            </div>

            {/* Botón */}
            <button
                onClick={() => setPopupStatus(false)}
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "10px",
                    width: "100%",
                    height: "52px",
                    border: "none",
                    borderRadius: "14px",
                    background: color_botton || "#6C63FF",
                    color: btnTextColor || "#FFFFFF",
                    fontSize: "16px",
                    fontWeight: "700",
                    cursor: "pointer",
                    boxShadow: `0 4px 16px ${color_botton ? color_botton + "44" : "rgba(108,99,255,0.28)"}`,
                    transition: "opacity 0.15s, transform 0.12s",
                    marginTop: "4px",
                }}
                onMouseDown={(e) => { e.currentTarget.style.transform = "scale(0.98)"; e.currentTarget.style.opacity = "0.88"; }}
                onMouseUp={(e) => { e.currentTarget.style.transform = "scale(1)"; e.currentTarget.style.opacity = "1"; }}
            >
                <span>Entendido</span>
                <IconArrowRight size={14} />
            </button>
        </div>
    );
};

export default PopUpProgramarNew2;
